// selectors.js
import { createSelector } from 'reselect';


const getSoTracking = (state) => state.AllTrackingData.sotrack;
export const selectSOTrackingData = createSelector(
  [getSoTracking],
  (so) => so || { data: [] }
);


const getCtInwMemo = (state) => state.NumberingDatalist.ctInw;
export const selectCtInwardMemo = createSelector(
  [getCtInwMemo],
  (so) => so || { data: [] }
);

const getNumMemo = (state) => state.NumberingDatalist.numMemo;
export const selectNumMemo = createSelector(
  [getNumMemo],
  (so) => so || { data: [] }
);


const getNumberinglist = (state) => state.NumberingDatalist.numberingList;
export const selectNumberingDatalist = createSelector(
  [getNumberinglist],
  (so) => so || { data: [], numberingInfo: [] }
);

const getNumberingInwardlist = (state) => state.NumberingDatalist.numberingInwList;
export const selectNumberingInwardDatalist = createSelector(
  [getNumberingInwardlist],
  (so) => so || { data: [], numberingInfo: [] }
);


const getNummemoforFusion = (state) => state.FusioningDatalist.num;
export const selectNumMemoFusion = createSelector(
  [getNummemoforFusion],
  (so) => so || { data: [] }
);

const getFusionmemo = (state) => state.FusioningDatalist.fmemo;
export const selectFusionMemo = createSelector(
  [getFusionmemo],
  (so) => so || { data: [] }
);

const getFusionlist = (state) => state.FusioningDatalist.fdata;
export const selectFusiondata = createSelector(
  [getFusionlist],
  (so) => so || { data: [], info: [] }
);

const getFusionInwlist = (state) => state.FusioningDatalist.finw;
export const selectFusionInwdata = createSelector(
  [getFusionInwlist],
  (so) => so || { data: [], info: [] }
);